import moment from 'moment'
import React, { useState, useEffect } from 'react'
import { Row, Col, Card, Progress, DatePicker, Affix, Skeleton } from 'antd'
import CalendarStatus from '../../Assets/Images/Status/calendar-status.png'
import dayjs from 'dayjs'
import { Link } from 'react-scroll'
import { useDispatch, useSelector } from 'react-redux'
import { SetDateFilterStatusReducer } from '../../Redux/Actions/Status/Status'
const loadImage = require.context("../../Assets/Images/Status", true)


const CardStatus = (props) => {

    const [indexItemSelected, setIndexItemSelected] = useState(null)
    const [dateYearMonth, setDateYearMonth] = useState('')
    const data_status = props.status
    const dispatch = useDispatch()

    const {
        rex_loading_data_status,
        rex_select_date_filter_status
    } = useSelector(({ status }) => status)

    useEffect(() => {
        if (rex_select_date_filter_status) {
            const date = dayjs(moment(rex_select_date_filter_status).format('DD/MM/YYYY'), 'DD/MM/YYYY')
            setDateYearMonth(date)

        } else {
            setDateYearMonth(dayjs())
        }

    }, [rex_select_date_filter_status]);

    return (
        <Affix offsetTop={78}>
            <Card className="Card-Circle-Status">
                <Row gutter={20}>
                    <Col lg={0} xs={24}>
                        <div className="Container-Title-Circle-Status">
                            <p>Área</p>
                            <p>% Avance</p>
                        </div>
                    </Col>
                    <Col lg={2} xs={0}>
                        <div className='Container-Item-Header-Status-Date'>
                            <img className='Image-Indicator-Status-Top' src={CalendarStatus}></img>
                            <div className='Container-Date-Filter-Status'>
                                <span>Fecha</span>
                                <DatePicker
                                    inputReadOnly={true}
                                    size='small'
                                    className='DatePicker-Filter-Status'
                                    allowClear={false}
                                    value={dateYearMonth}
                                    picker="month"
                                    popupClassName='DatePicker-Filter-Status-PopUp'
                                    suffixIcon={null}
                                    onChange={(e, date) => {
                                        dispatch(SetDateFilterStatusReducer(date))
                                        setDateYearMonth(dayjs(date))
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col lg={22} xs={24}>
                        <Row className='Container-Item-Header-Area' gutter={22}>
                            {
                                rex_loading_data_status
                                    ? <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Skeleton.Button active={true} style={{ height: '60px', width: '250px', borderRadius: '15px' }} size='large' block={false} />
                                        <Skeleton.Button active={true} style={{ height: '60px', width: '250px', borderRadius: '15px' }} size='large' block={false} />
                                        <Skeleton.Button active={true} style={{ height: '60px', width: '250px', borderRadius: '15px' }} size='large' block={false} />
                                    </div>
                                    : data_status.length > 0 && data_status.map((are, index) => {

                                        return (
                                            <Col lg={6} xs={24} key={index} className="Container-Item-Area">
                                                <a
                                                    style={{ width: "95%", display: "flex", justifyContent: "center" }}
                                                    href={indexItemSelected == index ? `#${are.areresponsable}` : undefined}
                                                >
                                                    <div
                                                        onClick={() => {
                                                            if (are.aremostrar) {
                                                                setIndexItemSelected(null)
                                                            }
                                                        }}
                                                        onMouseEnter={() => {
                                                            if (are.aremostrar) {
                                                                setIndexItemSelected(index)
                                                            }
                                                        }}
                                                        onMouseLeave={() => {
                                                            setIndexItemSelected(null)
                                                        }}
                                                        className={`Container-Section-Status ${indexItemSelected == index ? "Item-Selected" : ""} ${indexItemSelected == null ? "Section-Minimun-Space" : ""} ${are.aremostrar ? "" : "Card-Circle-Status-Not-Avaliable"}`}
                                                        style={{
                                                            background: "white",
                                                            borderRadius: "16px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "space-between",
                                                            width: "100%",
                                                            border: "1px solid rgba(240, 240, 250, 0.2)",
                                                            cursor: are.aremostrar ? "pointer" : "default",
                                                            opacity: are.aremostrar ? 1 : 0.6,
                                                            transition: "all 0.3s ease",
                                                            transform: indexItemSelected === index ? "translateY(-2px)" : "translateY(0)",
                                                        }}
                                                    >
                                                        <div
                                                            className="Image-background"
                                                            style={{
                                                                flex: 1,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            <img
                                                                className="Image-Indicator-Area-Top"
                                                                src={loadImage(`./${are.areicono || "/placeholder.svg"}`)}
                                                                alt={are.areicono}
                                                                width={140}
                                                                height={50}
                                                                style={{

                                                                }}
                                                            />
                                                        </div>
                                                        <div className="Image-background2">
                                                            <Progress
                                                                className="Percentage-Circle-Status"
                                                                type="circle"
                                                                percent={are.areporcentajeinicial}
                                                                strokeColor={
                                                                    are.areporcentajeinicial <= 70
                                                                        ? "#FA382D"
                                                                        : are.areporcentajeinicial <= 95
                                                                            ? "#FFC700"
                                                                            : "#2AD295"
                                                                }
                                                                trailColor="#C4D5FF"
                                                                width={70}
                                                                strokeWidth={8}
                                                                format={(percent) => `${percent}%`}
                                                            />
                                                            <Progress
                                                                className="Percentage-Linear-Status"
                                                                percent={are.areporcentajeinicial}
                                                                strokeColor={
                                                                    are.areporcentajeinicial <= 70
                                                                        ? "#FA382D"
                                                                        : are.areporcentajeinicial <= 95
                                                                            ? "#FFC700"
                                                                            : "#2AD295"
                                                                }
                                                                trailColor="#C4D5FF"
                                                                format={(percent) => `${percent}%`}
                                                                style={{ display: "none" }} // Oculto para mantener solo el circular como en la imagen
                                                            />
                                                        </div>
                                                    </div>
                                                </a>
                                            </Col>
                                        )
                                    }

                                    )
                            }
                        </Row>
                    </Col>
                </Row>
            </Card>
        </Affix>
    )
}

export default CardStatus